// Drop-in replacement for window.fetch that detects auth failures (401/403)
// and dispatches a global `ffai-auth-failed` event so App.js can clear the
// session, surface a toast, and redirect to /login. Same signature as fetch.

let authFailureDispatched = false;

export async function authFetch(input, init) {
  const response = await fetch(input, init);
  if (
    (response.status === 401 || response.status === 403) &&
    !authFailureDispatched
  ) {
    authFailureDispatched = true;
    setTimeout(() => {
      authFailureDispatched = false;
    }, 5000);
    window.dispatchEvent(
      new CustomEvent('ffai-auth-failed', {
        detail: {
          url: typeof input === 'string' ? input : input?.url,
          status: response.status,
        },
      })
    );
  }
  return response;
}
